import { IUpdateChecklistEntregaUseCase } from "../../../presentation/useCases/update/update_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateChecklistEntregaUseCase
 */

export class UpdateChecklistEntregaUseCase implements IUpdateChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntrega: number,
    codigo?: string,
    descricao?: string,
    revisao?: string,
    campo1?: string,
    campo2?: string,
    campo3?: string,
    campo4?: string,
    ativo?: boolean,
  ): Promise<void> {
    await this.repository.updateChecklistEntrega(
      idChecklistEntrega,
      codigo,
      descricao,
      revisao,
      campo1,
      campo2,
      campo3,
      campo4,
      ativo,
    );
  }
}
